import React from 'react';
import { render } from 'react-dom';
import LandingPage from './template';

// eslint-disable-next-line max-len
// TODO: @artivilla import this script across all desktop views that don't have mainnav on their page

render(
	<LandingPage
		encryptedId={ config.encryptedId }
		isInvitation={ config.isInvitation }
		csrf={ config.csrf }
		campaignText={ config.campaignText }
		companyNumber={ config.companyNumber }
		googleRecaptchaSiteKey={ config.googleRecaptchaSiteKey }
	/>,
	document.getElementById('landing-page-bucket')
);



// WEBPACK FOOTER //
// ./src/main/webapp/media/scripts/webpack/invitationlandingpage/index.js